import styled from 'styled-components';
import tw from 'tailwind.macro';

export const Banner = styled.section`
  ${tw` border-b border-indigo-100 `};
`;

export const Content = styled.p`
  ${tw`mb-8`};
`;
